import { render, staticRenderFns } from "./DoughnutPie.vue?vue&type=template&id=60483265"
import script from "./DoughnutPie.vue?vue&type=script&lang=ts"
export * from "./DoughnutPie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports